import { BadgeClassKey, StyleRules } from '@material-ui/core';

const MuiBadge: Partial<StyleRules<BadgeClassKey, {}>> = {
  colorError: {
    backgroundColor: 'rgb(255, 72, 66)',
  },
};

export default MuiBadge;
